module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABOAgMAAACiUPvtAAAADFBMVEX///9/f3+/v7+fn5/k+qrTAAAALUlEQVQ4y2MIxQEYqlZhBWsZEhiwAs5RiVGJUYlRiVGJUYlRCSwSuKvUUBwAAJDVTdGU3Ki1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/input_shop_bg.png
// module id = 546
// module chunks = 39